import React from "react";
import "./App.css";
import "./styles/pages.css";
import "./styles/priceDisplay.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import CartAnimationProvider from "./components/CartAnimationProvider";
import Home from "./pages/Home";
import About from "./pages/About";
import ProductRange from "./pages/ProductRange";
import EdibleCupsCategory from "./pages/EdibleCupsCategory";
import EdibleCup220 from "./pages/EdibleCup220";
import EdibleCup110 from "./pages/EdibleCup110";
import CutleryTableware from "./pages/CutleryTableware";
import EdibleSpoons from "./pages/EdibleSpoons";
import EdibleForks from "./pages/EdibleForks";
import EdibleCoffeeStirrer from "./pages/EdibleCoffeeStirrer";
import EdibleIceCreamSpoon from "./pages/EdibleIceCreamSpoon";
import FrenchFriesFork from "./pages/FrenchFriesFork";
import Certifications from "./pages/Certifications";
import CutleryCertifications from "./pages/CutleryCertifications";
import Blog from "./pages/Blog";
import BlogPlasticDetox from "./pages/BlogPlasticDetox";
import Contact from "./pages/Contact";
import Shop from "./pages/Shop";
import Account from "./pages/Account";
import OrderConfirmation from "./pages/OrderConfirmation";
import UseCases from "./pages/UseCases";
import EventsCatering from "./pages/useCases/EventsCatering";
import CoffeeProducers from "./pages/useCases/CoffeeProducers";
import HotelsRestaurantsCafes from "./pages/useCases/HotelsRestaurantsCafes";
import CorporationsCompanies from "./pages/useCases/CorporationsCompanies";
import PrivateGatherings from "./pages/useCases/PrivateGatherings";
import ScrollToTop from "./components/ScrollToTop";
import TermsConditions from "./components/legal/TermsConditions";
import PrivacyPolicy from "./components/legal/PrivacyPolicy";
import CookiePolicy from "./components/legal/CookiePolicy";
import DeliveryReturn from "./components/legal/DeliveryReturn";
import CookieConsent from "./components/CookieConsent";


function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <CartProvider>
            <BrowserRouter>
              <ScrollToTop />
              <Header />
              <CartDrawer />
              <CartAnimationProvider />
              <CookieConsent />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/product-range" element={<ProductRange />} />
                  <Route path="/product-range/edible-cups" element={<EdibleCupsCategory />} />
                  <Route path="/product-range/cutlery-tableware" element={<CutleryTableware />} />
                  <Route path="/edible-cups" element={<EdibleCupsCategory />} />
                  <Route path="/edible-cup-220" element={<EdibleCup220 />} />
                  <Route path="/edible-cup-110" element={<EdibleCup110 />} />
                  <Route path="/cutlery-tableware" element={<CutleryTableware />} />
                  <Route path="/cutlery-tableware/edible-spoons" element={<EdibleSpoons />} />
                  <Route path="/cutlery-tableware/edible-forks" element={<EdibleForks />} />
                  <Route path="/cutlery-tableware/edible-coffee-stirrer" element={<EdibleCoffeeStirrer />} />
                  <Route path="/cutlery-tableware/edible-ice-cream-spoon" element={<EdibleIceCreamSpoon />} />
                  <Route path="/cutlery-tableware/french-fries-fork" element={<FrenchFriesFork />} />
                  <Route path="/certifications" element={<Certifications />} />
                  <Route path="/cutlery-certifications" element={<CutleryCertifications />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/plastic-detox-rethinking-everyday-waste" element={<BlogPlasticDetox />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/account" element={<Account />} />
                  <Route path="/order-confirmation" element={<OrderConfirmation />} />
                  <Route path="/use-cases" element={<UseCases />} />
                  <Route path="/use-cases/events-and-catering" element={<EventsCatering />} />
                  <Route path="/use-cases/coffee-producers" element={<CoffeeProducers />} />
                  <Route path="/use-cases/hotels-restaurants-cafes" element={<HotelsRestaurantsCafes />} />
                  <Route path="/use-cases/corporations-companies" element={<CorporationsCompanies />} />
                  <Route path="/use-cases/private-gatherings" element={<PrivateGatherings />} />
                  <Route path="/terms-conditions" element={<TermsConditions />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/cookie-policy" element={<CookiePolicy />} />
                  <Route path="/delivery-return" element={<DeliveryReturn />} />
                </Routes>
              </main>
              <Footer />
            </BrowserRouter>
          </CartProvider>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
